// DbGridMenu/DbGridMenu.styles.ts
import { StyleSheet } from 'react-native';

const colors = {
  light: {
    background: '#FFFFFF',
    cardBackground: '#F7F8FA',
    text: '#333333',
    subText: '#999999',
    border: '#E8E8E8',
    divider: '#F0F0F0',
    primary: '#007AFF',
    badge: '#FF3B30',
    badgeText: '#FFFFFF',
    disabled: '#CCCCCC',
    tag: '#FF9500',
    tagText: '#FFFFFF',
  },
  dark: {
    background: '#1A1A1A',
    cardBackground: '#2A2A2A',
    text: '#FFFFFF',
    subText: '#999999',
    border: '#3A3A3A',
    divider: '#333333',
    primary: '#0A84FF',
    badge: '#FF453A',
    badgeText: '#FFFFFF',
    disabled: '#666666',
    tag: '#FF9F0A',
    tagText: '#000000',
  },
};

export const createStyles = (theme: 'light' | 'dark' = 'light') => {
  const c = colors[theme];

  return StyleSheet.create({
    // 容器
    container: {
      backgroundColor: c.background,
    },
    
    // 标题区域
    header: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingHorizontal: 12,
      paddingTop: 12,
      paddingBottom: 8,
    },
    headerLeft: {
      flexDirection: 'row',
      alignItems: 'center',
      flex: 1,
    },
    title: {
      fontSize: 17,
      fontWeight: '600',
      color: c.text,
    },
    headerRight: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingLeft: 12,
    },
    rightText: {
      fontSize: 14,
      color: c.subText,
      marginRight: 4,
    },
    
    // 分割线
    divider: {
      height: StyleSheet.hairlineWidth,
      backgroundColor: c.divider,
      marginHorizontal: 16,
    },
    
    // Grid 布局
    gridContainer: {
      flexDirection: 'column',
      paddingVertical: 12,
    },
    // Grid 行
    gridRow: {
      flexDirection: 'row',
      alignItems: 'flex-start',
    },
    
    // Scroll 布局
    scrollContainer: {
      paddingVertical: 12,
    },
    scrollContent: {
      flexDirection: 'row',
      paddingHorizontal: 12,
    },
    scrollItemWrapper: {
      marginHorizontal: 6,
    },
    
    // 菜单项
    gridItem: {
      alignItems: 'center',
      justifyContent: 'center',
      paddingVertical: 12,
    },
    scrollItem: {
      alignItems: 'center',
      justifyContent: 'center',
      paddingVertical: 12,
      paddingHorizontal: 16,
      minWidth: 80,
    },
    itemWithBackground: {
      backgroundColor: c.cardBackground,
      borderRadius: 12,
      paddingVertical: 16,
      paddingHorizontal: 12,
    },
    itemDisabled: {
      opacity: 0.5,
    },
    
    // 图标容器
    iconContainer: {
      width: 56,
      height: 56,
      borderRadius: 16,
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: 8,
      position: 'relative',
    },
    iconContainerSmall: {
      width: 48,
      height: 48,
      borderRadius: 12,
    },
    
    // 徽标
    badge: {
      position: 'absolute',
      top: -4,
      right: -4,
      minWidth: 18,
      height: 18,
      borderRadius: 9,
      backgroundColor: c.badge,
      alignItems: 'center',
      justifyContent: 'center',
      paddingHorizontal: 5,
      borderWidth: 2,
      borderColor: c.background,
    },
    badgeText: {
      fontSize: 10,
      fontWeight: '600',
      color: c.badgeText,
    },
    
    // 标签
    tag: {
      position: 'absolute',
      top: 0,
      right: 0,
      paddingHorizontal: 6,
      paddingVertical: 2,
      borderRadius: 8,
      backgroundColor: c.tag,
    },
    tagText: {
      fontSize: 9,
      fontWeight: '600',
      color: c.tagText,
    },
    
    // 文字
    itemText: {
      fontSize: 13,
      color: c.text,
      textAlign: 'center',
      marginTop: 4,
    },
    itemTextDisabled: {
      color: c.disabled,
    },
  });
};

export const GRID_MENU_DEFAULTS = {
  columns: 3,
  gap: 12,
  padding: 12,
  horizontalPadding: 0,
  itemRadius: 12,
  iconSize: 28,
};
